import { render, staticRenderFns } from "./ReportPresences.vue?vue&type=template&id=5922779d&scoped=true&"
import script from "./ReportPresences.vue?vue&type=script&lang=js&"
export * from "./ReportPresences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5922779d",
  null
  
)

export default component.exports